import { Provider } from "react-redux";
import { NotificationContainer } from "react-notifications";
import { WPToastNotification } from "./packages/WPToastNotification";
import { BrowserRouter as Router } from "react-router-dom";
import CAStore from "./Store/TemplateStore/template.store";

import SSOProvider from "./components/SSOProvider.js";
import { AppRoutes } from "./Routes.js";
import { saveItemSession } from "./utils/session.js";

import "./styles/vendors/style.js";

export const store = CAStore;

window.onbeforeunload = (event) => {
  console.log("app+onbeforeunload", window.location.href);
  const lastVisitedURL = window.location.pathname + window.location.search;

  if (!lastVisitedURL.includes("code=")) {
    console.log("save lastVisitedURL", lastVisitedURL);
    saveItemSession("lastVisitedURL", lastVisitedURL);
  } else {
    console.log("remove lastVisitedURL");
    saveItemSession("lastVisitedURL", "");
  }

  event.preventDefault();
  event.returnValue = "";
};

function App() {
  return (
    <Provider store={store}>
      <Router>
        <SSOProvider
          clientId={process.env.REACT_APP_CONSUMER_KEY}
          redirectUri={process.env.REACT_APP_REDIRECT_URI}
        >
          <AppRoutes />
        </SSOProvider>
      </Router>

      <NotificationContainer />
      <WPToastNotification />
    </Provider>
  );
}

export default App;
